import trebuchetRegular from "../../assets/fonts/TREBUC.TTF";
import trebuchetBold from "../../assets/fonts/TREBUCBD.TTF";
import trebuchetBoldItalic from "../../assets/fonts/TREBUCBI.TTF";
import trebuchetItalic from "../../assets/fonts/TREBUCIT.TTF";
import { Font, StyleSheet } from "@react-pdf/renderer";

Font.register({
  family: "Trebuchet",
  fonts: [
    { src: trebuchetRegular },
    { src: trebuchetBold, fontWeight: "bold" },
    { src: trebuchetItalic, fontStyle: "italic" },
    { src: trebuchetBoldItalic, fontWeight: "bold", fontStyle: "italic" },
  ],
});

const styles = StyleSheet.create({
  // === PÁGINA RESUMEN (primera) ===
  page: {
    padding: 20,
    fontFamily: "Trebuchet",
    backgroundColor: "#000000",
    flexDirection: "column",
  },
  headerBar: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#2ce67c",
    padding: 10,
    borderRadius: 5,
    marginBottom: 12,
  },
  logo: {
    width: 60,
    height: "auto",
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#000000",
  },
  headerDate: {
    fontSize: 10,
    color: "#000000",
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginBottom: 15,
    paddingVertical: 10,
    borderBottom: "1 solid #2ce67c",
  },
  summaryItem: {
    alignItems: "center",
  },
  summaryNumber: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#2ce67c",
  },
  summaryLabel: {
    fontSize: 9,
    color: "#ffffff",
    marginTop: 2,
  },

  // === TABLA RESUMEN ===
  listTable: {
    width: "100%",
    border: "1 solid #333",
    fontSize: 8,
  },
  listHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#2ce67c",
    fontWeight: "bold",
  },
  listHeaderCell: {
    padding: 5,
    textAlign: "center",
    borderRight: "1 solid rgba(0,0,0,0.2)",
    color: "#000000",
    fontWeight: "bold",
  },
  listRow: {
    flexDirection: "row",
    borderBottom: "1 solid #333",
    backgroundColor: "#1a1a1a",
  },
  listRowAlt: {
    flexDirection: "row",
    borderBottom: "1 solid #333",
    backgroundColor: "#111111",
  },
  listCell: {
    padding: 4,
    textAlign: "center",
    borderRight: "1 solid #333",
    color: "#ffffff",
  },
  listCellLeft: {
    padding: 4,
    textAlign: "left",
    paddingLeft: 8,
    borderRight: "1 solid #333",
    color: "#ffffff",
  },

  // Separador entre tabla y fichas
  separator: {
    borderBottom: "2 solid #2ce67c",
    marginVertical: 15,
    width: "100%",
  },

  // === PÁGINAS DE FICHAS TÉCNICAS ===
  fichasPage: {
    padding: 15,
    fontFamily: "Trebuchet",
    backgroundColor: "#000000",
    flexDirection: "column",
    justifyContent: "flex-start",
  },

  // Fila de 2 fichas
  fichasRow: {
    flexDirection: "row",
    gap: 8,
    marginBottom: 8,
  },

  // Ficha individual (mitad del ancho)
  fichaCard: {
    flexDirection: "row",
    border: "1.5 solid #ffffff",
    borderRadius: 6,
    height: 200,
    width: "49.5%",
    overflow: "hidden",
  },

  // Columna imagen (izq)
  fichaImageCol: {
    width: "32%",
    backgroundColor: "#111111",
  },
  fichaImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  fichaImagePlaceholder: {
    width: "100%",
    height: "100%",
    backgroundColor: "#1a1a1a",
    alignItems: "center",
    justifyContent: "center",
  },
  fichaPlaceholderText: {
    color: "#666666",
    fontSize: 10,
  },

  // Columna info (der)
  fichaInfoCol: {
    width: "68%",
    padding: 8,
    flexDirection: "column",
    justifyContent: "space-between",
  },

  // Nombre
  fichaNombreBar: {
    backgroundColor: "#2ce67c",
    padding: 4,
    paddingHorizontal: 8,
    borderRadius: 4,
    marginBottom: 4,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fichaNombre: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#000000",
  },
  fichaInstalacion: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#ffffff",
    backgroundColor: "#ff0000",
    padding: 3,
    paddingHorizontal: 6,
    borderRadius: 3,
  },

  // Dirección
  fichaDireccion: {
    fontSize: 7,
    color: "#cccccc",
    marginBottom: 5,
  },

  // Dispositivos
  fichaDispositivosRow: {
    flexDirection: "row",
    gap: 8,
    marginBottom: 5,
  },
  fichaDispItem: {
    alignItems: "center",
    backgroundColor: "#1a1a1a",
    padding: 4,
    paddingHorizontal: 8,
    borderRadius: 4,
    border: "1 solid #2ce67c",
  },
  fichaDispNum: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#2ce67c",
  },
  fichaDispLabel: {
    fontSize: 6,
    color: "#ffffff",
    marginTop: 1,
  },

  // Personas y empresas
  fichaBottomRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: "auto",
  },
  fichaPersonas: {
    alignItems: "center",
  },
  fichaPersonasNum: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#2ce67c",
  },
  fichaPersonasLabel: {
    fontSize: 6,
    color: "#ffffff",
    textTransform: "uppercase",
  },
  fichaEmpresas: {
    alignItems: "flex-end",
  },
  fichaEmpresasNum: {
    fontSize: 8,
    color: "#ffffff",
    fontWeight: "bold",
  },
  fichaEmpresasDest: {
    fontSize: 6,
    color: "#aaaaaa",
    marginTop: 1,
    maxWidth: 160,
    textAlign: "right",
  },

  // Footer de página fichas
  fichaPageFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "auto",
    paddingTop: 5,
  },
  fichaFooterLogo: {
    width: 40,
    height: "auto",
  },
  fichaFooterText: {
    fontSize: 8,
    color: "#666666",
  },
});

export default styles;
